import { ReactNode } from 'react';
import { VariantProps } from 'tailwind-variants';
import { NewContentCardProvider } from '../useNewContentCardContext';
import { ContentWrapper } from '../variants';

interface INewContentCardRootProps {
  children?: ReactNode;
  contentType: 'lesson' | 'exercise' | 'material' | 'essay';
  contentId: string;
  contentSlug: string;
  discipline: string;
  selected?: boolean;
  onClick?: () => void;
  subject?: string;
}

export function NewContentCardRoot(props: INewContentCardRootProps) {
  return (
    <NewContentCardProvider
      contentType={props.contentType}
      contentId={props.contentId}
      contentSlug={props.contentSlug}
      subject={props.subject}
      discipline={props.discipline}
    >
      <div
        className={ContentWrapper({
          color: props.discipline as VariantProps<
            typeof ContentWrapper
          >['color'],
          selected: props.selected,
        })}
        id={props.contentId}
        onClick={props.onClick}
      >
        {props.children}
      </div>
    </NewContentCardProvider>
  );
}
